import displayName from 'component-lib/displayName';
import Column from './Column';

export default function ExpandColumn(props) {
    return Column(props);
}

ExpandColumn.displayName = displayName('Forms/InputGroup/ExpandColumn');

ExpandColumn.defaultProps = {
    tdStyle: 'expand-column',
};
